// extracted by mini-css-extract-plugin
module.exports = {"Lander":"Start_Lander__3t3Wi","BottomVersion":"Start_BottomVersion__3KdnP"};